import axios from 'axios'
import { baseUrl } from '../constants/Connections'
import { tryToJson } from '../utils/util'

export const api = axios.create({
    baseURL: baseUrl, // lets you stop repeating baseUrl in options if you want
})

export async function trackAnalyticsEvent(data) {
    return api({ method: 'POST', url: '/api/screen_events', data })
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token')

    if (token) {
        config.headers = config.headers || {}
        if (!config.headers.Authorization) {
            config.headers.Authorization = token
        }
    }
    try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
        if (tz) {
            config.headers = config.headers || {}
            config.headers['X-Timezone'] = tz
        }
    } catch (_) {}

    return config
})

export async function login({ email, password }) {
    const options = {
        method: 'POST',
        url: '/api/login',
        data: {
            email,
            password,
        },
    }

    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getById({ collection, id }) {
    const options = {
        method: 'GET',
        url: `/api/by_id/${collection}/${id}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getStudentDailyQuestionUsage() {
    const options = {
        method: 'GET',
        url: `/api/student_daily_question_usage`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getDashboardStatisticsNew() {
    const options = {
        method: 'GET',
        url: `/api/dash_statistics_new`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getAnalyticsDashboardStats(days = 7) {
    const options = {
        method: 'GET',
        url: `/api/analytics_dashboard_statistics?days=${days}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const getNumberOfNegativeEmotions = async () => {
    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        url: `/api/number_of_negative_emotions`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getWellbeingProfilesForReviewAsync() {
    const options = {
        method: 'GET',
        url: `/api/wellbeing_profile_for_review`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getActionRequiredStats() {
    const options = {
        method: 'GET',
        url: `/api/actions_required_stats`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getMonitoringStats() {
    const options = {
        method: 'GET',
        url: `/api/monitoring_stats`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function createMonitoringGroup(data) {
    const options = {
        method: 'POST',
        url: `/api/monitoring_group`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function createTeacherAsync(data) {
    const options = {
        method: 'POST',
        url: `/api/teacher_management`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function deleteMonitoringGroup(id) {
    const options = {
        method: 'DELETE',
        url: `/api/monitoring_group?id=${id}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function removeContentFromTrendsAsync(id) {
    const options = {
        method: 'DELETE',
        url: `/api/analytics_content?id=${id}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getYearsForTeacher() {
    const options = {
        method: 'GET',
        url: `/api/school_years_for_teachers`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getClassroomTrendReport(period) {
    const options = {
        method: 'GET',
        url: `/api/classroom_trend_report_advanced?period=${period}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function takeTutorial(currentStep) {
    const options = {
        method: 'GET',
        url: `/api/take_tutorial?device=desktop&step=${currentStep}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function ifUserNeedsTutorial() {
    const options = {
        method: 'GET',
        url: `/api/need_tutorial?device=desktop`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getCurrentFeatureAnnouncement(locale = 'en') {
    const options = {
        method: 'GET',
        url: `/api/feature_announcements/current?platform=web&locale=${encodeURIComponent(locale)}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function recordFeatureAnnouncementInteraction({ announcementId, interactionType, lastStep }) {
    const options = {
        method: 'POST',
        url: `/api/feature_announcements/${announcementId}/interaction`,
        data: { interaction_type: interactionType, last_step: lastStep },
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function ifUserHasPrimaryClasses() {
    const options = {
        method: 'GET',
        url: `/api/teacher_has_primary_classes`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function ifUserHasRegularClasses() {
    const options = {
        method: 'GET',
        url: `/api/teacher_has_regular_classes`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getMonitoringStatsForTargetGroup(id, days = 7, previousWeek = false) {
    const options = {
        method: 'GET',
        url: `/api2/monitoring_stats_for_target_group?id=${id}&days=${days}&previous_week=${previousWeek}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function downloadMonitoringStatsForTargetGroup(id, days = 7, format = 'csv') {
    const params = new URLSearchParams({ id, days, download: 'true' })
    if (format === 'xlsx') params.set('format', 'xlsx')
    const options = {
        method: 'GET',
        url: `/api2/monitoring_stats_for_target_group?${params.toString()}`,
        responseType: 'arraybuffer',
    }
    return api(options)
        .then((response) => ({
            status: response.status,
            data: response.data,
            contentType: response.headers['content-type'],
        }))
        .catch((error) => handelError(error))
}
export async function getDefaultMonitoringStats() {
    const options = {
        method: 'GET',
        url: `/api2/default_monitoring_stats`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getMonitoringGroups() {
    const options = {
        method: 'GET',
        url: `/api/monitoring_groups`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getTeachersForAssignment({ student_id = null }) {
    const options = {
        method: 'GET',
        url: `/api/free_teachers_for_assignment?student_id=${student_id}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const getSuperiorTeachers = async (user) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        url: `/api/student_superiors`,
        data: user,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const getJournalForUser = async (id) => {
    const options = {
        method: 'GET',
        url: `/api/journal_for_user/${id}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const updateJournalDailyQuestion = async (user) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        url: `/api/respond_to_journal_question`,
        data: user,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function request_new_password(data) {
    const options = {
        method: 'POST',
        url: `/api/reset_password`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function checkSolutionAccess(data) {
    const options = {
        method: 'POST',
        url: `/api/checkSolutionAccess`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function contactExpert(data) {
    const options = {
        method: 'POST',
        url: `/api/contactExpert`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getRunningPrograms(data) {
    const options = {
        method: 'POST',
        url: `/api/get_running_programs`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getResponseSuggestions(data) {
    const options = {
        method: 'POST',
        url: `/api/get_response_suggestions`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getSurveys() {
    const options = {
        method: 'GET',
        url: `/api/get_surveys`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getSurveysForUser() {
    const options = {
        method: 'GET',
        url: `/api/get_student_surveys`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function find_counsellor(data) {
    const options = {
        method: 'POST',
        url: `/api/find_counsellor`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function find_sos(data) {
    const options = {
        method: 'POST',
        url: `/api/find_sos`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getCheckUsersFeedback() {
    const options = {
        method: 'GET',
        url: `/api/check_if_users_feedback_is_needed`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function sendRejectReview() {
    const options = {
        method: 'GET',
        url: `/api/reject_review`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function collectUsersFeedback(data) {
    const options = {
        method: 'POST',
        url: `/api/collect_users_feedback`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function checkIfTakeDailyFeedback(user_id) {
    const options = {
        method: 'GET',
        url: `/api/last_daily_feedback/${user_id}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getMostPopularEmotionForUser(user_id) {
    const options = {
        method: 'GET',
        url: `/api/most_popular_emotion/${user_id}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getUserResponsePercentage(user_id) {
    const options = {
        method: 'GET',
        url: `/api/user_response_percentage/${user_id}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getCatchUpsAsync(data) {
    const options = {
        method: 'POST',
        url: `/api/catch_ups`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function answer(data) {
    const options = {
        method: 'POST',
        url: `/api/answer`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getFeeds(data, signal) {
    const options = {
        method: 'POST',
        url: `/api/get_feed`,
        data,
        signal,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getPinnedFeedPosts() {
    const options = {
        method: 'GET',
        url: `/api/feed_pins`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function pinFeedPost(contentId, confirmed = false) {
    const options = {
        method: 'POST',
        url: `/api/feed_pins/${contentId}`,
        data: { confirmed },
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function unpinFeedPost(contentId) {
    const options = {
        method: 'DELETE',
        url: `/api/feed_pins/${contentId}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function deleteById({ collection, id }) {
    const options = {
        method: 'DELETE',
        url: `/api/by_id/${collection}/${id}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function stopContent({ id }) {
    const options = {
        method: 'GET',
        url: `/api/stop_content?content_id=${id}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
// Stops this run and removes every scheduled (unpublished) run of its recurrence.
export async function stopContentSeries({ id }) {
    const options = {
        method: 'GET',
        url: `/api/stop_content?content_id=${id}&scope=series`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
// Deletes this run and every scheduled (unpublished) run of its recurrence;
// runs that already went live stay as history.
export async function deleteContentSeries(id) {
    const options = {
        method: 'DELETE',
        url: `/api/content_series/${id}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const respondToDailyQuestion = async (data) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        url: `/api/respondToDailyQuestion`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function searchFeeds({ user, number_of_feeds, text }) {
    const data = {
        user,
        number_of_feeds,
        text,
    }
    const options = {
        method: 'POST',
        url: `/api/get_feed`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
// Short-lived token for the file server, so the session token never has to go into a URL.
export async function getMediaToken() {
    return api({ method: 'GET', url: '/api/media/token' })
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getByToken() {
    const token = localStorage.getItem('token')
    if (!!token) {
        const options = {
            method: 'GET',
            headers: {},
            url: '/api/users/me',
        }
        return api(options)
            .then((response) => handleSuccess(response))
            .catch((error) => handelError(error))
    }
    return { status: 300, data: 'No token' }
}
export async function getContentByTopic(topic, locale = 'en') {
    const options = {
        method: 'GET',
        url: `/api/ready_to_go_content?topic=${topic}&locale=${locale}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getTasks({ user_id, number_of_tasks }) {
    const data = {
        user_id,
        number_of_tasks,
    }
    const options = {
        method: 'POST',
        url: `/api_v2/get_task`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

// The signed-in user's own archive (tasks they answered), newest first. `before` is the
// opaque `next_cursor` of the previous page; `counts` only comes back on a first page without `q`.
export async function getMyArchive({ type = 'all', before = null, limit = 20, q = '' } = {}) {
    const params = { type, limit }
    if (before) params.before = before
    if (q) params.q = q
    return api({ method: 'GET', url: '/api/student/archive', params })
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

// A student's archive as seen by staff: scoped to students the caller may see, with
// anonymous content left out and journal answers withheld by the API.
export async function getStaffStudentArchive({ student_id, type = 'all', before = null, limit = 20, q = '' } = {}) {
    const params = { student_id, type, limit }
    if (before) params.before = before
    if (q) params.q = q
    return api({ method: 'GET', url: '/api/staff/student_archive', params })
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function like({ user_id, feed_id, like }) {
    const data = {
        user_id,
        feed_id,
        like,
    }
    const options = {
        method: 'POST',
        url: `/api/like`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const getMessageList = async (data) => {
    const options = {
        method: 'POST',
        url: `/api/message_list`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const checkProgramOverlap = async (data) => {
    const options = {
        method: 'POST',
        url: `/api/check_program_overlap`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const runProgram = async (data) => {
    const options = {
        method: 'POST',
        url: `/api/run_program`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getProgramHistory(data) {
    const options = {
        method: 'POST',
        url: `/api/get_program_history`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getMessages = async ({ members, loaded_messages, conversation_id }) => {
    const data = {
        members,
        loaded_messages,
        conversation_id,
    }
    const options = {
        method: 'POST',
        url: `/api/get_messages`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const sendMessage = async (data) => {
    const options = {
        method: 'POST',
        url: `/api/send_message`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const seenMessage = async (data) => {
    const options = {
        method: 'POST',
        url: `/api/seen_message`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getTarget = async (data) => {
    const options = {
        method: 'POST',
        url: `/api/get_target`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getAllStudentsTarget = async () => {
    const options = {
        method: 'GET',
        url: `/api/all_students_target`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getUsersLoginsInfo = async () => {
    const options = {
        method: 'GET',
        url: `/api/user_logins_info`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
// Whether the school's credentials file is actually in the bucket - the file
// server answers a missing one with an error page.
export const getMasterListAvailability = async () => {
    const options = {
        method: 'GET',
        url: `/api/master_list/availability`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const selectAllStaffAsync = async () => {
    const options = {
        method: 'GET',
        url: `/api/all_staff_target`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getSurveyResult(survey_id, sectionIndex, questionIndex, classId) {
    const options = {
        method: 'GET',
        url: `/api/survey_result?survey_id=${survey_id}&section_index=${sectionIndex}&question_index=${questionIndex}&class_id=${classId}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getSurveyResults(survey_id, classId) {
    const options = {
        method: 'GET',
        url: `/api/survey_results?survey_id=${survey_id}&class_id=${classId}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getUsersLoginsInfoDetailed = async () => {
    const options = {
        method: 'POST',
        url: `/api/user_logins_info`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const getContentPrograms = async () => {
    const options = {
        method: 'GET',
        url: `/api/all/programs`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getPrograms = async (locale = 'en') => {
    const options = {
        method: 'GET',
        url: `/api/get_programs?local=${locale}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getAnalyticsHowDoYouFillStats = async () => {
    const options = {
        method: 'GET',
        url: `/api/how_do_you_feel_stats`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const getAnalyticsBasic = async (user, number_of_users = 0, searchText = '') => {
    const options = {
        method: 'GET',
        url: `/api/basic_login_stats?role=${user}&search=${searchText}&loaded=${number_of_users}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function deleteStudentAsync(data = {}) {
    const options = {
        method: 'POST',
        url: `/api/delete_student`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function deleteClassAsync(data = {}) {
    const options = {
        method: 'POST',
        url: `/api/delete_class`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const getUpstriveWeeklyUsage = async (user, number_of_users = 0, searchText = '') => {
    const options = {
        method: 'GET',
        url: `/api/upstrive_weekly_usage?search=${searchText}&loaded=${number_of_users}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getUpstriveWeeklyUsagePercentage = async (user, number_of_users = 0, searchText = '') => {
    const options = {
        method: 'GET',
        url: `/api/upstrive_weekly_usage_percentage`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getContentResponseRate = async (number_of_users = 0, searchText = '') => {
    const options = {
        method: 'GET',
        url: `/api/content_response_rate?search=${searchText}&loaded=${number_of_users}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getContentResponseRatePercentage = async () => {
    const options = {
        method: 'GET',
        url: `/api/content_response_rate_percentage`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const getUsersLoginStats = async (user) => {
    const options = {
        method: 'GET',
        url: `/api/user_login_stats?role=${user}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const getContentSurveys = async () => {
    const options = {
        method: 'GET',
        url: `/api/get_surveys`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getAdditionalTrends = async (days) => {
    const options = {
        method: 'GET',
        url: `/api/additional_trends?days=${days}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const sendMessageToStudentFromFeedback = async (data) => {
    const options = {
        method: 'POST',
        url: `/api/send_message_to_student_from_feedback`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getContentJournals = async () => {
    const options = {
        method: 'GET',
        url: `/api/get_journals_model`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getUpcomingNum = async () => {
    const options = {
        method: 'GET',
        url: `/api/upcoming_content`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getNumberOfContentForReview = async () => {
    const options = {
        method: 'GET',
        url: `/api/number_of_content_for_review`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getContentForReview = async (loaded) => {
    const options = {
        method: 'GET',
        url: `/api/content_for_reviewing?loaded=${loaded}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getContentPreviewTargets = async ({ contentId, programId }) => {
    const args = contentId ? `content_id=${contentId}` : `program_id=${programId}`
    const options = {
        method: 'GET',
        url: `/api/content/preview_targets?${args}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getUpcomingContent = async (data) => {
    const options = {
        method: 'POST',
        url: `/api/upcoming_content`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getJournalById = async (journalId) => {
    const options = {
        method: 'GET',
        url: `/api/journal_results?journal_id=${journalId}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getJournalForDay = async (journalId, day) => {
    const options = {
        method: 'GET',
        url: `/api/journal_results_for_day?journal_id=${journalId}&day=${day}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getConversationInfo = async (conversationId) => {
    const options = {
        method: 'GET',
        url: `/api/conversation_info?conversation_id=${conversationId}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const loadTargetItemsList = async (data) => {
    const options = {
        method: 'POST',
        url: `/api/target_list`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const create = async ({ collection, data }) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        url: `/api/all/${collection}`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const createConversation = async (data) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        url: `/api/create_conversation`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const createContent = async ({ data }) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        url: `/api/create_content`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const createTemplate = async ({ data }) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        url: `/api/all/template`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

// Staff templates (feed / question / poll / survey). The server takes the
// author and school from the token and decides who may change what; each list
// item comes back with `author`, `visibility` ('private' | 'school') and `can_manage`.
export const listTemplates = async ({ type, scope = 'mine', loaded = 0, text = '' }) => {
    const options = {
        method: 'POST',
        url: `/api/templates/list`,
        data: { type, scope, loaded, text },
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const saveTemplate = async ({ type, visibility, data }) => {
    const options = {
        method: 'POST',
        url: `/api/templates`,
        data: { type, visibility, data },
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const updateTemplateById = async ({ type, id, visibility, data }) => {
    const options = {
        method: 'PUT',
        url: `/api/templates/${type}/${id}`,
        data: { visibility, data },
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const setTemplateVisibility = async ({ type, id, visibility }) => {
    const options = {
        method: 'PUT',
        url: `/api/templates/${type}/${id}/visibility`,
        data: { visibility },
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const deleteTemplate = async ({ type, id }) => {
    const options = {
        method: 'DELETE',
        url: `/api/templates/${type}/${id}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const hideWellbeingNote = async ({ data }) => {
    const options = {
        method: 'POST',
        url: `/api/hide_wellbeing_message`,
        headers: {
            'Content-Type': 'application/json',
        },
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const upload = async (file) => {
    // ImagePicker saves the taken photo to disk and returns a local URI to it
    let type = file.type.includes('video') ? 'video' : 'image'

    // Upload the image using the fetch and FormData APIs
    let formData = new FormData()
    // Assume "photo" is the name of the form field the server expects
    formData.append('file', file)

    return api
        .post(`/api/upload?type=${type}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const uploadUserData = async (file, institutionId) => {
    let formData = new FormData()
    formData.append('file', file)

    return api
        .post(`/api/uploadUsersData?institution_id=${institutionId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const uploadFileToServer = async (file, type = 'pdf') => {
    const token = localStorage.getItem('token')
    let formData = new FormData()
    formData.append('file', file)

    return axios
        .post(`${baseUrl}/api/upload?type=${type}`, formData, {
            headers: {
                Authorization: `${token}`,
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const removeUserDataFile = async (file) => {
    const options = {
        url: `/api/uploadUsersData?file_id=${file.id}`,
        method: 'DELETE',
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function update({ collection, data }) {
    const options = {
        method: 'PUT',
        data: data,
        url: `/api/by_id/${collection}/${data?.id}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function update_new_password({ email, password, token }) {
    const data = {
        email,
        password,
        token,
    }
    const options = {
        method: 'PUT',
        url: `/api/update_new_password`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function find_head_of_class(data) {
    const options = {
        method: 'POST',
        url: `/api/find_head_of_class`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function createUser(data) {
    const options = {
        method: 'POST',
        url: `/api/create_user`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function draftSurveyAsync(data) {
    const options = {
        method: 'POST',
        url: `/api/draft_survey_response`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function verify_reset_token({ email, token }) {
    const options = {
        method: 'GET',
        url: `/api/verify_reset_token/${email}/${token}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getFavoriteGroupsAsync() {
    const options = {
        method: 'GET',
        url: `/api/favorite_groups`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getAll({ type }) {
    const options = {
        method: 'GET',
        url: `/api/all/${type}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function logUserTimeAsync(data) {
    const options = {
        method: 'POST',
        url: `/api/log_user_time`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function logLoginTimeAsync(data) {
    const options = {
        method: 'POST',
        url: `/api/log_login_time`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getUnseenConversations() {
    const options = {
        method: 'GET',
        url: `/api/unseen_conversations`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getNumberOfWellbeingProfilesForReviewAsync() {
    const options = {
        method: 'GET',
        url: `/api/number_of_wellbeing_profile_for_review`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function sendNotification(data) {
    const options = {
        method: 'POST',
        url: `/api/sendNotification`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function approveContentAsync(data) {
    const options = {
        method: 'POST',
        url: `/api/review_content`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function changeProgramStatus(data) {
    const options = {
        method: 'POST',
        url: `/api/change_program_status`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function removeRunningProgram(data) {
    const options = {
        method: 'POST',
        url: `/api/remove_running_program`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getIssues({ issueType, loadedContent, searchText }) {
    const data = {
        loadedContent: loadedContent,
        issueType: issueType,
        searchText: searchText || '',
    }

    const options = {
        method: 'POST',
        url: `/api/get_issues`,
        data,
    }

    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function solutionLike(data) {
    const options = {
        method: 'POST',
        url: `/api/solutionLike`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function solutionDislike(data) {
    const options = {
        method: 'POST',
        url: `/api/solutionDislike`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getCounsellingProfile(data) {
    const options = {
        method: 'POST',
        url: `/api/counselling_profiles`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError('Error getting all terminals' + error))
}
export async function makeAssignment(data) {
    const options = {
        method: 'POST',
        url: `/api/make_assignment`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError('Error getting all terminals' + error))
}
export async function setAssignmentStatus(data) {
    const options = {
        method: 'POST',
        url: `/api/assignment_status`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getStudentSupportHistory(studentId, feedbackId) {
    const options = {
        method: 'GET',
        url: `/api/student_analytics/support_history?student_id=${studentId}&feedback_id=${feedbackId}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getNumberProfilesForReview() {
    const options = {
        method: 'GET',
        url: `/api/number_of_wellbeing_profile_for_review`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError('Error getting all terminals' + error))
}
export async function getUploadsHistory() {
    const options = {
        method: 'GET',
        url: `/api/users_data_history`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError('Error getting uploads history' + error))
}

export async function getScheduledEmails() {
    const token = localStorage.getItem('token')
    const options = {
        method: 'GET',
        url: `${baseUrl}/api/scheduled_emails`,
        headers: { Authorization: token },
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError('Error getting scheduled emails' + error))
}

export async function scheduleEmail(scheduleData, confirmOverwrite = false) {
    const token = localStorage.getItem('token')
    const options = {
        method: 'POST',
        url: `${baseUrl}/api/onboarding_users_data/schedule_email${confirmOverwrite ? '?confirm_overwrite=true' : ''}`,
        headers: { Authorization: token },
        data: scheduleData,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        // The error itself, not a string: the caller reads the 409 for custom passwords off it.
        .catch((error) => handelError(error))
}
export async function getScheduledJobs(task_id) {
    const token = localStorage.getItem('token')
    const options = {
        method: 'GET',
        url: `${baseUrl}/api/onboarding_users_data/schedule_email?task_id=${task_id}`,
        headers: { Authorization: token },
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError('Error getting scheduled jobs' + error))
}
export async function deleteScheduledJob(task_id) {
    const token = localStorage.getItem('token')
    const options = {
        method: 'DELETE',
        url: `${baseUrl}/api/onboarding_users_data/schedule_email?id=${task_id}`,
        headers: { Authorization: token },
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError('Error getting scheduled jobs' + error))
}
export async function getReminders(data) {
    const options = {
        method: 'POST',
        url: `/api/find_reminders`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getWellbeingReview() {
    const options = {
        method: 'GET',
        url: `/api/wellbeing_profile_for_review`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getWellbeingUsers(data) {
    const options = {
        method: 'POST',
        url: `/api/wellbeing_users`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function openWellbeingProfile(data) {
    const options = {
        method: 'POST',
        url: `/api/open_wellbeing_profile`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function viewFeedPost(data) {
    const options = {
        method: 'POST',
        url: `/api/view_post`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getLiveResults(data, signal) {
    const options = {
        method: 'POST',
        data,
        url: `/api/live_results_advanced`,
        signal,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function get_teachers(data) {
    const options = {
        method: 'POST',
        data,
        url: `/api/get_list/teachers`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
// `confirmOverwrite` is sent once the user accepted the "school has custom passwords" prompt;
// without it the backend answers 409 for such schools and changes nothing.
export async function generate_new_password(data, confirmOverwrite = false) {
    const options = {
        method: 'POST',
        data,
        url: `/api/generate_password_send_mail${confirmOverwrite ? '?confirm_overwrite=true' : ''}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function email_exists(email) {
    const options = {
        method: 'GET',
        url: `/api/email_exists/${email}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getSchoolYears() {
    const options = {
        method: 'GET',
        url: `/api/school_years_for_teacher_role`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getSchoolClasses() {
    const options = {
        method: 'GET',
        url: `/api/school_classes_for_teacher_role`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getInstitutionRoles() {
    const options = {
        method: 'GET',
        url: `/api/my_institution/roles`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function get_my_class(data) {
    const options = {
        method: 'POST',
        url: `/api/my_class_report`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const loadPrimaryStudents = async () => {
    const options = {
        method: 'GET',
        url: `/api/primary_students`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const getClasses = async () => {
    const options = {
        method: 'GET',
        url: `/api/get_classes`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getAdditionalFields = async () => {
    const options = {
        method: 'GET',
        url: `/api/additional_fields`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const getReports = async () => {
    const options = {
        method: 'GET',
        url: `/api/list_of_reports`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getThreeReports = async () => {
    const options = {
        method: 'GET',
        url: `/api/list_of_reports_three`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export const getFilters = async () => {
    const options = {
        method: 'GET',
        url: `/api/filter_for_reports`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const moveStudentToAnotherClass = async (data) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        url: `/api/move_student_to_another_class`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const changeUserAnimal = async (data) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        url: `/api/change_user_avatar`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function updateStudent(data = {}, confirmOverwrite = false) {
    const options = {
        method: 'POST',
        url: `/api/update_student${confirmOverwrite ? '?confirm_overwrite=true' : ''}`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function updateClassAsync(data = {}) {
    const options = {
        method: 'POST',
        url: `/api/update_class`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function searchClasses(data) {
    const options = {
        method: 'POST',
        url: `/api/get_list/classes`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function generateLoginQRCodeForStudent(student_id) {
    const options = {
        method: 'GET',
        url: `/api/generate_qr_code_data_for_student?student_id=${student_id}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function get_students(data) {
    const options = {
        method: 'POST',
        url: `/api/get_list/students`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getStudentsForClass({ institution_id, className }) {
    const options = {
        method: 'POST',
        url: `/api/get_list_admin/students`,
        data: { institution_id, className },
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getDayArchive(data) {
    const options = {
        method: 'POST',
        url: `/api/get_day_archive`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function sendSeenFeedbackComment(data) {
    const options = {
        method: 'POST',
        url: `/api/seen_feedback_comment`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function takeActionFeedbackComment(data) {
    const options = {
        method: 'POST',
        url: `/api/take_action_feedback_comment`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function addCounsellorNote(counsellingProfileId, data) {
    const args = `?counselling_profile_id=${counsellingProfileId}`
    const options = {
        method: 'POST',
        url: `/api/add_counselling_note${args}`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
// export async function get_by({ collection = '', query = {}, page = -1, page_size = -1, sort_field = '', sort_direction = 1 }) {
//     const args = `?page=${page}&page_size=${page_size}&sort_field=${sort_field}&sort_direction=${sort_direction}&query=${JSON.stringify(query)}`
//     const options = {
//         method: 'GET',
//         url: `/api/filter_by/${collection}${args}`,
//     }
//     return api(options)
//         .then((response) => handleSuccess(response))
//         .catch((error) => handelError(error))
// }
export async function getAnalyticsContent(data) {
    const options = {
        method: 'POST',
        url: `/api/get_analytics_content`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function analyze(data) {
    const options = {
        method: 'POST',
        url: `/api/analyze`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const agreeToTermsAndPolicy = async (user) => {
    const options = {
        method: 'POST',
        date: Date.now(),
        headers: {
            'Content-Type': 'application/json',
        },
        url: `/api/agreeToTermsAndPolicy`,
        data: user,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function generateCustomReport(data) {
    const options = {
        method: 'POST',
        url: `/api/generate_custom_report`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

// Students analytics
export async function getStudentAnalyticsInfo(studentId) {
    const options = {
        method: 'GET',
        url: `/api/student_analytics?student_id=${studentId}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function sendReminder(studentId, data) {
    const options = {
        method: 'POST',
        data,
        url: `/api/student_analytics/send_reminder?student_id=${studentId}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function sendClassReminder(classId, data) {
    const options = {
        method: 'POST',
        data,
        url: `/api/class_analytics/send_reminder?class_id=${classId}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function loadStudentCheckingData(studentId, startDate, endDate) {
    const options = {
        method: 'GET',
        url: `/api/student_analytics/checking?student_id=${studentId}&start_date=${startDate}&end_date=${endDate}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function loadStudentActivityData(studentId, startDate, endDate) {
    const options = {
        method: 'GET',
        url: `/api/student_analytics/activity?student_id=${studentId}&start_date=${startDate}&end_date=${endDate}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function loadStudentAlertsAsync(studentId, startDate, endDate, alertType) {
    const options = {
        method: 'GET',
        url: `/api/student_analytics/alerts?student_id=${studentId}&start_date=${startDate}&end_date=${endDate}&alert_type=${alertType}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function seenAlert(alert_id) {
    const options = {
        method: 'GET',
        url: `/api/student_analytics/alerts/seen?id=${alert_id}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function loadStudentHasAlertsAsync(studentId, startDate, endDate) {
    const options = {
        method: 'GET',
        url: `/api/student_analytics/has_alerts?student_id=${studentId}&start_date=${startDate}&end_date=${endDate}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function loadAssignedActionsForStudentAsync(studentId, startDate, endDate) {
    const options = {
        method: 'GET',
        url: `/api/student_analytics/assigned_actions?student_id=${studentId}&start_date=${startDate}&end_date=${endDate}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function loadStudentWellbeingData(studentId, startDate, endDate, skipDays = 0) {
    const options = {
        method: 'GET',
        url: `/api/student_analytics/general_wellbeing?student_id=${studentId}&start_date=${startDate}&end_date=${endDate}&skip_days=${skipDays}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function loadStudentWellbeingSchoolYEarData(studentId) {
    const options = {
        method: 'GET',
        url: `/api/student_analytics/school_year_wellbeing?student_id=${studentId}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function loadStudentWellbeingCompareData(studentId, startDate, endDate, target) {
    const options = {
        method: 'GET',
        url: `/api/student_analytics/general_wellbeing_compare?student_id=${studentId}&start_date=${startDate}&end_date=${endDate}&target=${target}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function loadStudentReasonsData(studentId, startDate, endDate, skipDays = 0) {
    const options = {
        method: 'GET',
        url: `/api/student_analytics/student_reasons?student_id=${studentId}&start_date=${startDate}&end_date=${endDate}&skip_days=${skipDays}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function loadStudentWellbeingComparison(studentId, startDate, endDate, selectedClassId = null, skipDays = 0) {
    const options = {
        method: 'GET',
        url: `/api/student_analytics/wellbeing_comparison?student_id=${studentId}&start_date=${startDate}&end_date=${endDate}&skip_days=${skipDays}${
            selectedClassId ? `&class_id=${selectedClassId}` : ''
        }`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function loadContentForStudent(studentId, startDate, endDate, loadedData = 0, searchText = '') {
    const options = {
        method: 'GET',
        url: `/api/student_analytics/content_for_student?student_id=${studentId}&start_date=${startDate}&end_date=${endDate}&loaded_data=${loadedData}&search_text=${encodeURIComponent(searchText)}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function loadStudentDetailedEmotionsAsync(studentId, startDate, endDate) {
    const options = {
        method: 'GET',
        url: `/api/student_analytics/detailed_emotions?student_id=${studentId}&start_date=${startDate}&end_date=${endDate}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const searchStudentForAnalytics = async ({ loadedData, searchText, classId = null, yearGroup = null }) => {
    const options = {
        method: 'GET',
        url: yearGroup !== null ? `/api/year_analytics/students?${new URLSearchParams({ year: yearGroup, search_text: searchText, loaded_students: loadedData })}` : `/api/student_analytics/search_single_student?search_text=${encodeURIComponent(searchText)}&loaded_students=${loadedData}&class_id=${classId}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
// Class analytics
export async function getClassAnalyticsInfo(class_id) {
    const options = {
        method: 'GET',
        url: `/api/class_analytics?class_id=${class_id}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const searchClassForAnalytics = async ({ loadedData, searchText }) => {
    const options = {
        method: 'GET',
        url: `/api/class_analytics/search_single_class?search_text=${searchText}&loaded_classes=${loadedData}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadCLassWellbeingSchoolYearData(classId) {
    const options = {
        method: 'GET',
        url: `/api/class_analytics/school_year_wellbeing?class_id=${classId}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadClassCheckingData(classId, startDate, endDate) {
    const options = {
        method: 'GET',
        url: `/api/class_analytics/checking?class_id=${classId}&start_date=${startDate}&end_date=${endDate}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadClassWellbeingComparison(classId, startDate, endDate, customData = {}, skipDays = 0) {
    const options = {
        method: 'POST',
        url: `/api/class_analytics/wellbeing_comparison?class_id=${classId}&start_date=${startDate}&end_date=${endDate}`,
        data: customData,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadClassDetailedEmotionsAsync(classId, startDate, endDate) {
    const options = {
        method: 'GET',
        url: `/api/class_analytics/detailed_emotions?class_id=${classId}&start_date=${startDate}&end_date=${endDate}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadAssignedActionsForClassAsync(classId, startDate, endDate) {
    const options = {
        method: 'GET',
        url: `/api/class_analytics/assigned_actions?class_id=${classId}&start_date=${startDate}&end_date=${endDate}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadClassAlertsAsync(classId, startDate, endDate, alertType) {
    const options = {
        method: 'GET',
        url: `/api/class_analytics/alerts?class_id=${classId}&start_date=${startDate}&end_date=${endDate}&alert_type=${alertType}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadClassReasonsData(classId, startDate, endDate, skipDays = 0) {
    const options = {
        method: 'GET',
        url: `/api/class_analytics/class_reasons?class_id=${classId}&start_date=${startDate}&end_date=${endDate}&skip_days=${skipDays}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function loadClassWellbeingByStudents(classId, startDate, endDate, loadedStudents = 0, limit = 5) {
    const options = {
        method: 'GET',
        url: `/api/class_analytics/wellbeing_by_students?class_id=${classId}&start_date=${startDate}&end_date=${endDate}&loaded_students=${loadedStudents}&limit=${limit}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadClassEngagementStats(classId, startDate, endDate) {
    const options = {
        method: 'GET',
        url: `/api/class_analytics/class_engagement_stats?class_id=${classId}&start_date=${startDate}&end_date=${endDate}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadContentForClass(classId, startDate, endDate, loadedData = 0, searchText = '') {
    const options = {
        method: 'GET',
        url: `/api/class_analytics/content_for_class?class_id=${classId}&start_date=${startDate}&end_date=${endDate}&loaded_data=${loadedData}&search_text=${encodeURIComponent(searchText)}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadSingleClassReport(data) {
    const options = {
        method: 'POST',
        url: `/api/single_class_report`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function resetClassReport(data) {
    const options = {
        method: 'POST',
        url: `/api/reset_class_report`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function searchPrimaryClasses(data = {}) {
    const options = {
        method: 'POST',
        url: `/api/get_list/primary_classes`,
        data: data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getEmotionDistribution() {
    const options = {
        method: 'GET',
        url: `/api/emotion_distribution`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function findAlerts({ loadedData, typeFilter, assignedFilter, years = [], classes = [] }) {
    // Repeated params rather than a comma list: class names are free text.
    const repeated = (key, values) =>
        values
            .filter((v) => v && v !== 'all')
            .map((v) => `&${key}=${encodeURIComponent(v)}`)
            .join('')
    const options = {
        method: 'GET',
        url: `/api/alerts?limit=10&skip=${loadedData}${!!typeFilter ? `&alert_type=${typeFilter}` : ''}${!!assignedFilter ? `&assign_type=${assignedFilter}` : ''}${repeated('years', years)}${repeated('classes', classes)}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function saveHelpUsScoreForAlert(data) {
    const options = {
        method: 'POST',
        url: `/api/alerts/save_score`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function markAlertAsFalsePositive(data) {
    const options = {
        method: 'POST',
        url: `/api/alerts/false_positive`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getAlertNotificationsSettings() {
    const options = {
        method: 'GET',
        url: `/api/alerts/notifications_settings`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getSchoolEmails() {
    const options = {
        method: 'GET',
        url: `/api/alerts/school_emails`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function saveAlertNotificationsSettings(data) {
    const options = {
        method: 'PUT',
        url: `/api/alerts/notifications_settings`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function agreeToAlertTerms() {
    const options = {
        method: 'POST',
        url: `/api/alerts/agree`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function createCustomAlert(data) {
    const options = {
        method: 'POST',
        url: `/api/alerts/custom_mark`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getLastEmotions() {
    const options = {
        method: 'GET',
        url: `/api/last_primary_emotions`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

// Organization analytics
export async function getOrganizationAnalyticsInfo(data) {
    const options = {
        method: 'POST',
        url: `/api/organization_analytics/organization_info`,
        headers: {
            'Content-Type': 'application/json',
        },
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getSurveyAnalytics(data) {
    const options = {
        method: 'POST',
        url: `/api/survey_analytics`,
        headers: {
            'Content-Type': 'application/json',
        },
        data, // { survey_id, selected_filters, user_ids, start_date, end_date }
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
// Downloads the Pulse Check analytics as a PDF. Same request body as
// getSurveyAnalytics (plus an optional `locale`); returns the raw binary so the
// caller can trigger a browser download. Mirrors downloadMonitoringStatsForTargetGroup.
export async function downloadSurveyAnalyticsReport(data) {
    const options = {
        method: 'POST',
        url: `/api/survey_analytics/report`,
        headers: {
            'Content-Type': 'application/json',
        },
        data, // { survey_id, selected_filters, user_ids, start_date, end_date, locale }
        responseType: 'arraybuffer',
    }
    return api(options)
        .then((response) => ({
            status: response.status,
            data: response.data,
            contentType: response.headers['content-type'],
        }))
        .catch((error) => handelError(error))
}

export async function getStudentPulseHistory(studentId, startDate, endDate) {
    const options = {
        method: 'GET',
        url: `/api/survey_analytics/student_history?student_id=${studentId}&start_date=${startDate}&end_date=${endDate}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getOrganizationCheckingFrequencyAnalyticsInfo(data, startDate, endDate) {
    const options = {
        method: 'POST',
        url: `/api/organization_analytics/checking_frequency?start_date=${startDate}&end_date=${endDate}`,
        headers: {
            'Content-Type': 'application/json',
        },
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getFiltersForOrganizationAnalytics() {
    const options = {
        method: 'GET',
        url: `/api/organization_analytics/filters`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadOrganizationCheckingData(data, startDate, endDate) {
    const options = {
        method: 'POST',
        url: `/api/organization_analytics/checking?start_date=${startDate}&end_date=${endDate}`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadOrganizationReasonsData(data, startDate, endDate, skipDays = 0) {
    const options = {
        method: 'POST',
        url: `/api/organization_analytics/organization_reasons?start_date=${startDate}&end_date=${endDate}&skip_days=${skipDays}`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadOrganizationDetailedEmotionsAsync(data, startDate, endDate) {
    const options = {
        method: 'POST',
        url: `/api/organization_analytics/detailed_emotions?start_date=${startDate}&end_date=${endDate}`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

// A year payload always uses the protected year endpoints, including an empty
// year value (which the server rejects). It must never fall back to school scope.
const counsellorAnalyticsBase = (data) => Object.prototype.hasOwnProperty.call(data || {}, 'yearGroup')
    ? '/api/year_analytics' : '/api/counsellor_analytics'

export const searchYearForAnalytics = async ({ searchText = '', loadedData = 0 }) => api({
    method: 'GET',
    url: `/api/year_analytics/years?${new URLSearchParams({ search_text: searchText, loaded_data: loadedData })}`,
}).then(handleSuccess).catch(handelError)

export const loadYearAnalyticsMetric = async (metric, data, params = {}) => api({
    method: 'POST', url: `/api/year_analytics/${metric}?${new URLSearchParams(params)}`, data,
}).then(handleSuccess).catch(handelError)

export const getYearAnalyticsInfo = (data) => loadYearAnalyticsMetric('info', data)
export const loadYearComparison = (data, start, end, alerts = false) => loadYearAnalyticsMetric(
    alerts ? 'alerts' : 'wellbeing_comparison', data, { start_date: start, end_date: end })

// Counsellor analytics
export async function getCounsellorAnalyticsInfo(data) {
    const options = {
        method: 'POST',
        url: `${counsellorAnalyticsBase(data)}/${data?.yearGroup !== undefined ? 'info' : 'counsellor_info'}`,
        headers: {
            'Content-Type': 'application/json',
        },
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadContentForCounsellor(data, start_date, end_date, loadedData = 0, searchText = '') {
    const options = {
        method: 'POST',
        url: `${counsellorAnalyticsBase(data)}/content_for_counsellor?start_date=${start_date}&end_date=${end_date}&loaded_data=${loadedData}&search_text=${encodeURIComponent(searchText)}`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadCounsellorReasonsData(data, startDate, endDate, skipDays = 0) {
    const options = {
        method: 'POST',
        url: `${counsellorAnalyticsBase(data)}/counsellor_reasons?start_date=${startDate}&end_date=${endDate}&skip_days=${skipDays}`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadCounsellorDetailedEmotionsAsync(data, startDate, endDate) {
    const options = {
        method: 'POST',
        url: `${counsellorAnalyticsBase(data)}/detailed_emotions?start_date=${startDate}&end_date=${endDate}`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadCounsellorCheckingData(data, startDate, endDate) {
    const options = {
        method: 'POST',
        url: `${counsellorAnalyticsBase(data)}/checking?start_date=${startDate}&end_date=${endDate}`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function loadCounsellorWellbeingComparison(data, startDate, endDate, skipDays = 0) {
    const options = {
        method: 'POST',
        url: `${counsellorAnalyticsBase(data)}/wellbeing_comparison?start_date=${startDate}&end_date=${endDate}&skip_days=${skipDays}`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function loadOrganizationWellbeingComparison(data, startDate, endDate, skipDays = 0) {
    const options = {
        method: 'POST',
        url: `/api/organization_analytics/wellbeing_comparison?start_date=${startDate}&end_date=${endDate}&skip_days=${skipDays}`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function loadCounsellorAlerts(data, startDate, endDate, skipDays = 0) {
    const options = {
        method: 'POST',
        url: `${counsellorAnalyticsBase(data)}/alerts?start_date=${startDate}&end_date=${endDate}&skip_days=${skipDays}`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getFilersForCounsellorsAnalytics() {
    const options = {
        method: 'GET',
        url: `/api/counsellor_analytics/filters`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getTemplates(data) {
    const options = {
        method: 'POST',
        url: `/api/get_templates`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export const getPrivateNotes = async (notes) => {
    const options = {
        method: 'GET',
        url: `/api/private_notes?number_of_notes=${notes}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getCurrentClassesAndStaff() {
    const token = localStorage.getItem('token')
    const options = {
        method: 'GET',
        url: `${baseUrl}/api/onboarding/current_classes_and_staff`,
        headers: {
            Authorization: `${token}`,
        },
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getImportStatus(taskId) {
    try {
        const response = await axios.get(`${baseUrl}/api/onboarding_users_data/${taskId}/status`)
        return response.data
    } catch (error) {
        console.error('Error getting import status:', error)
        throw new Error('Failed to get import status')
    }
}

export async function sendDataForUploading(data) {
    const token = await localStorage.getItem('token')
    const options = {
        method: 'POST',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/onboarding_users_data`,
        data,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}
export async function getUploadDataDetails() {
    const token = await localStorage.getItem('token')
    const options = {
        method: 'GET',
        headers: {
            Authorization: `${token}`,
        },
        url: `${baseUrl}/api/onboarding_users_data`,
    }
    return axios(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

// ---- Student Inactivity Alerts ----
export async function getInactivity({ loadedData = 0, limit = 25, threshold } = {}) {
    const thresholdQuery = threshold ? `&threshold=${threshold}` : ''
    const options = {
        method: 'GET',
        url: `/api/inactivity?skip=${loadedData}&limit=${limit}${thresholdQuery}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

// Count only, at the school's configured threshold. Unlike getInactivity this
// is not an access to the named list, so the backend does not audit-log it.
export async function getInactivityCount() {
    const options = {
        method: 'GET',
        url: `/api/inactivity/count`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getInactivitySettings() {
    const options = {
        method: 'GET',
        url: `/api/inactivity/settings`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function saveInactivitySettings(data) {
    const options = {
        method: 'PUT',
        url: `/api/inactivity/settings`,
        data,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

// Returns an arraybuffer so the caller can trigger a browser CSV download.
// Mirrors downloadMonitoringStatsForTargetGroup.
export async function downloadInactivityExport({ threshold } = {}) {
    // Pass the same threshold the list is filtered by, so an export matches the
    // view it was taken from.
    const thresholdQuery = threshold ? `?threshold=${threshold}` : ''
    const options = {
        method: 'GET',
        url: `/api/inactivity/export${thresholdQuery}`,
        responseType: 'arraybuffer',
    }
    return api(options)
        .then((response) => ({
            status: response.status,
            data: response.data,
            contentType: response.headers['content-type'],
        }))
        .catch((error) => handelError(error))
}

export async function getChatAnalyticsSchoolFilters() {
    const options = {
        method: 'GET',
        url: '/api/chat_analytics/school_filters',
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function getChatAnalyticsSchoolStats(filters = {}) {
    const params = new URLSearchParams()
    Object.entries(filters).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length) params.set(key, value.join(','))
        else if (value !== undefined && value !== null && value !== '') params.set(key, value)
    })
    const options = {
        method: 'GET',
        url: `/api/chat_analytics/school_stats?${params.toString()}`,
    }
    return api(options)
        .then((response) => handleSuccess(response))
        .catch((error) => handelError(error))
}

export async function downloadClassQRSheet(institution_id, class_id) {
    const options = {
        method: 'GET',
        url: `/api/institutions/${institution_id}/classes/${class_id}/qr-sheet`,
        responseType: 'arraybuffer',
    }
    return api(options)
        .then((response) => ({
            status: response.status,
            data: response.data,
            contentType: response.headers['content-type'],
        }))
        .catch((error) => handelError(error))
}

function handelError(error) {
    console.log(error)
    return { status: error?.response?.status, data: error?.response?.data }
}
function handleSuccess(response) {
    const responseData = tryToJson(response.data)
    return { status: response.status, data: responseData }
}
